<template>
  <div class="app-container">
    <el-card shadow="never" class="query-card">
      <el-form :model="query" ref="queryForm" :inline="true" v-show="showSearch">
        <el-form-item label="角色名称" prop="name">
          <el-input
            v-model="query.name"
            placeholder="请输入角色名称"
            clearable
            size="small"
            style="width: 240px"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="权限字符" prop="code">
          <el-input
            v-model="query.code"
            placeholder="请输入权限字符"
            clearable
            size="small"
            style="width: 240px"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select
            v-model="query.status"
            placeholder="角色状态"
            clearable
            size="small"
            style="width: 240px"
          >
            <el-option label="正常" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
          <el-button
            type="primary"
            plain
            icon="el-icon-plus"
            size="mini"
            @click="handleAdd"
          >新增</el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button
            type="success"
            plain
            icon="el-icon-edit"
            size="mini"
            :disabled="single"
            @click="handleUpdate"
          >修改</el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button
            type="danger"
            plain
            icon="el-icon-delete"
            size="mini"
            :disabled="multiple"
            @click="handleDelete"
          >删除</el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button
            type="warning"
            plain
            icon="el-icon-download"
            size="mini"
            @click="handleExport"
          >导出</el-button>
        </el-col>
        <div class="right-tool">
          <el-tooltip class="item" effect="dark" :content="showSearch ? '隐藏搜索' : '显示搜索'" placement="top">
            <el-button size="mini" circle icon="el-icon-search" @click="showSearch=!showSearch" />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="刷新" placement="top">
            <el-button size="mini" circle icon="el-icon-refresh" @click="fetchList" />
          </el-tooltip>
        </div>
      </el-row>

      <el-table v-loading="loading" :data="roleList" @selection-change="handleSelectionChange" border>
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column label="角色编号" prop="id" width="120" />
        <el-table-column label="角色名称" prop="name" :show-overflow-tooltip="true" />
        <el-table-column label="权限字符" prop="code" :show-overflow-tooltip="true" />
        <el-table-column label="显示顺序" prop="sort" width="100" />
        <el-table-column label="状态" align="center" width="100">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="handleStatusChange(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" prop="createTime" width="180">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="180">
          <template slot-scope="scope">
            <div class="operation-cell">
              <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)"
              >修改</el-button>
              <el-button
                size="mini"
                type="text"
                icon="el-icon-delete"
                class="danger-text"
                @click="handleDelete(scope.row)"
              >删除</el-button>
              <el-dropdown size="mini" @command="(command) => handleCommand(command, scope.row)">
                <span class="el-dropdown-link">
                  <i class="el-icon-d-arrow-right el-icon--right"></i>更多
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="handleDataScope" icon="el-icon-circle-check">数据权限</el-dropdown-item>
                  <el-dropdown-item command="handleAuthUser" icon="el-icon-user">分配用户</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          :current-page="pageNo"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>

    <!-- 添加或修改角色对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入角色名称" />
        </el-form-item>
        <el-form-item label="权限字符" prop="code">
          <span slot="label">
            <el-tooltip content="控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasRole('admin')`)" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
            权限字符
          </span>
          <el-input v-model="form.code" placeholder="请输入权限字符" />
        </el-form-item>
        <el-form-item label="角色顺序" prop="sort">
          <el-input-number v-model="form.sort" controls-position="right" :min="0" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="菜单权限">
          <el-checkbox v-model="menuExpand" @change="handleCheckedTreeExpand($event, 'menu')">展开/折叠</el-checkbox>
          <el-checkbox v-model="menuNodeAll" @change="handleCheckedTreeNodeAll($event, 'menu')">全选/全不选</el-checkbox>
          <el-checkbox v-model="form.menuCheckStrictly" @change="handleCheckedTreeConnect($event, 'menu')">父子联动</el-checkbox>
          <el-tree
            class="tree-border"
            :data="menuOptions"
            show-checkbox
            ref="menu"
            node-key="id"
            :check-strictly="!form.menuCheckStrictly"
            empty-text="加载中，请稍后"
            :props="defaultProps"
          ></el-tree>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 分配数据权限（与若依 dataScope 1～5 对齐） -->
    <el-dialog :title="dataScopeTitle" :visible.sync="openDataScope" width="520px" append-to-body>
      <el-form :model="scopeForm" label-width="88px">
        <el-form-item label="角色名称">
          <el-input v-model="scopeForm.name" :disabled="true" />
        </el-form-item>
        <el-form-item label="权限字符">
          <el-input v-model="scopeForm.code" :disabled="true" />
        </el-form-item>
        <el-form-item label="权限范围">
          <el-select v-model="scopeForm.dataScope" style="width: 100%" @change="dataScopeSelectChange">
            <el-option
              v-for="item in dataScopeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-show="scopeForm.dataScope === '2'" label="数据权限">
          <el-checkbox v-model="deptExpand" @change="handleCheckedTreeExpand($event, 'dept')">展开/折叠</el-checkbox>
          <el-checkbox v-model="deptNodeAll" @change="handleCheckedTreeNodeAll($event, 'dept')">全选/全不选</el-checkbox>
          <el-checkbox v-model="scopeForm.deptCheckStrictly" @change="handleCheckedTreeConnect($event, 'dept')">父子联动</el-checkbox>
          <el-tree
            class="tree-border"
            :data="deptOptions"
            show-checkbox
            default-expand-all
            ref="deptScope"
            node-key="id"
            :check-strictly="!scopeForm.deptCheckStrictly"
            empty-text="加载中，请稍后"
            :props="deptTreeProps"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitDataScope">确 定</el-button>
        <el-button @click="cancelDataScope">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listRoles,
  createRole,
  updateRole,
  deleteRole,
  getRole,
  getRoleMenuIds,
  getRoleDeptIds,
  assignRoleMenus,
  updateRoleDataScope
} from '@/api/system/role';
import { getMenuTree } from '@/api/system/menu';
import { getDeptTree } from '@/api/system/dept';

export default {
  name: "Role",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 角色表格数据
      roleList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 数据权限对话框
      openDataScope: false,
      dataScopeTitle: '分配数据权限',
      deptExpand: true,
      deptNodeAll: false,
      deptOptions: [],
      deptTreeProps: {
        children: 'children',
        label: 'deptName'
      },
      dataScopeOptions: [
        { value: '1', label: '全部数据权限' },
        { value: '2', label: '自定数据权限' },
        { value: '3', label: '本部门数据权限' },
        { value: '4', label: '本部门及以下数据权限' },
        { value: '5', label: '仅本人数据权限' }
      ],
      scopeForm: {
        id: undefined,
        name: '',
        code: '',
        dataScope: '1',
        deptCheckStrictly: true
      },
      // 是否显示天数
      menuExpand: false,
      menuNodeAll: false,
      // 菜单列表
      menuOptions: [],
      // 查询参数
      query: {
        name: undefined,
        code: undefined,
        status: undefined
      },
      pageNo: 1,
      pageSize: 10,
      // 表单参数
      form: {
        status: 1,
        menuCheckStrictly: true
      },
      defaultProps: {
        children: "children",
        label: "name"
      },
      // 表单校验
      rules: {
        name: [
          { required: true, message: "角色名称不能为空", trigger: "blur" }
        ],
        code: [
          { required: true, message: "权限字符不能为空", trigger: "blur" }
        ],
        sort: [
          { required: true, message: "角色顺序不能为空", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.fetchList();
    this.getMenuTreeselect();
  },
  methods: {
    /** 查询角色列表 */
    async fetchList() {
      this.loading = true;
      try {
        const params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          ...this.query
        };
        const response = await listRoles(params);
        this.roleList = response.data.records;
        this.total = response.data.total;
      } finally {
        this.loading = false;
      }
    },
    /** 查询菜单树结构 */
    async getMenuTreeselect() {
      const response = await getMenuTree();
      this.menuOptions = response.data;
    },
    // 获取所有完全勾选的菜单节点 ID（不包含半勾选的父节点）
    getMenuAllCheckedKeys() {
      if (!this.$refs.menu) return [];
      const checked = this.$refs.menu.getCheckedNodes() || [];
      const ids = checked.map(n => n && n.id).filter(id => id != null);
      return ids.map(id => (typeof id === 'number' ? id : Number(id))).filter(n => !isNaN(n));
    },
    // 提交角色基础字段及菜单权限，PUT 接口一次性更新
    getUpdatePayload() {
      const { id, name, code, sort, status, remark } = this.form;
      const menuIds = this.getMenuAllCheckedKeys();
      return { id, name, code, sort, status, remark, menuIds };
    },
    /** 角色状态修改 */
    handleStatusChange(row) {
      let text = row.status === 1 ? "启用" : "停用";
      this.$confirm('确认要"' + text + '""' + row.name + '"角色吗？', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        await updateRole(row.id, { id: row.id, status: row.status });
        this.$message.success(text + "成功");
      }).catch(() => {
        row.status = row.status === 1 ? 0 : 1;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      if (this.$refs.menu != undefined) {
        this.$refs.menu.setCheckedKeys([]);
      }
      this.menuExpand = false;
      this.menuNodeAll = false;
      this.form = {
        id: undefined,
        name: undefined,
        code: undefined,
        sort: 0,
        status: 1,
        menuIds: [],
        remark: undefined,
        menuCheckStrictly: true
      };
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.pageNo = 1;
      this.fetchList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.query = {
        name: undefined,
        code: undefined,
        status: undefined
      };
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
    // 树权限（展开/折叠）
    handleCheckedTreeExpand(value, type) {
      if (type === 'menu') {
        const treeList = this.menuOptions;
        for (let i = 0; i < treeList.length; i++) {
          const node = this.$refs.menu && this.$refs.menu.store.nodesMap[treeList[i].id];
          if (node) node.expanded = value;
        }
      } else if (type === 'dept') {
        const treeList = this.deptOptions;
        for (let i = 0; i < treeList.length; i++) {
          const node = this.$refs.deptScope && this.$refs.deptScope.store.nodesMap[treeList[i].id];
          if (node) node.expanded = value;
        }
      }
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll(value, type) {
      if (type === 'menu') {
        this.$refs.menu.setCheckedNodes(value ? this.menuOptions : []);
      } else if (type === 'dept') {
        this.$refs.deptScope.setCheckedNodes(value ? this.deptOptions : []);
      }
    },
    // 树权限（父子联动）
    handleCheckedTreeConnect(value, type) {
      if (type === 'menu') {
        this.form.menuCheckStrictly = value ? true : false;
      } else if (type === 'dept') {
        this.scopeForm.deptCheckStrictly = !!value;
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加角色";
    },
    /** 修改按钮操作 */
    async handleUpdate(row) {
      this.reset();
      const roleId = row.id || this.ids;
      // 这里应该获取详情，但目前暂时用列表数据
      const target = row.id ? row : this.roleList.find(i => i.id === roleId[0]);
      this.form = { ...target, menuCheckStrictly: true };
      this.open = true;
      this.title = "修改角色";
      
      const resp = await getRoleMenuIds(roleId);
      const menuIds = Array.isArray(resp) ? resp : (resp && resp.data) || [];
      this.$nextTick(() => {
        if (this.$refs.menu) {
          this.$refs.menu.setCheckedKeys(menuIds);
        }
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          if (this.form.id != undefined) {
            await updateRole(this.form.id, this.getUpdatePayload());
            this.$message.success("修改成功");
          } else {
            this.form.menuIds = this.getMenuAllCheckedKeys();
            const res = await createRole(this.form);
            const newId = (res && res.data && res.data.id) ? res.data.id : (res && res.data) || res;
            const ids = this.form.menuIds;
            if (ids.length > 0) {
              await assignRoleMenus(newId, ids);
            }
            this.$message.success("新增成功");
          }
          this.open = false;
          this.fetchList();
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const roleIds = row.id || this.ids;
      this.$confirm('是否确认删除角色编号为"' + roleIds + '"的数据项？', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        if (Array.isArray(roleIds)) {
            for(const id of roleIds) {
                await deleteRole(id);
            }
        } else {
            await deleteRole(roleIds);
        }
        this.fetchList();
        this.$message.success("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.$message.info("导出功能待实现");
    },
    handlePageChange(page) {
      this.pageNo = page;
      this.fetchList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.fetchList();
    },
    dataScopeSelectChange(value) {
      if (value !== '2' && this.$refs.deptScope) {
        this.$refs.deptScope.setCheckedKeys([]);
      }
    },
    getDeptAllCheckedKeys() {
      if (!this.$refs.deptScope) return [];
      const checkedKeys = this.$refs.deptScope.getCheckedKeys() || [];
      const halfKeys = this.$refs.deptScope.getHalfCheckedKeys() || [];
      return [...new Set([...halfKeys, ...checkedKeys])];
    },
    cancelDataScope() {
      this.openDataScope = false;
      if (this.$refs.deptScope) {
        this.$refs.deptScope.setCheckedKeys([]);
      }
    },
    async submitDataScope() {
      if (!this.scopeForm.id) return;
      const deptIds =
        this.scopeForm.dataScope === '2'
          ? this.getDeptAllCheckedKeys().map((id) => (typeof id === 'number' ? id : Number(id))).filter((n) => !isNaN(n))
          : [];
      await updateRoleDataScope(this.scopeForm.id, {
        dataScope: String(this.scopeForm.dataScope),
        deptIds
      });
      this.$message.success('修改成功');
      this.openDataScope = false;
      this.fetchList();
    },
    async handleDataScope(row) {
      this.dataScopeTitle = '分配数据权限';
      this.deptExpand = true;
      this.deptNodeAll = false;
      try {
        const [roleRes, treeRes, deptIdsRes] = await Promise.all([
          getRole(row.id),
          getDeptTree(),
          getRoleDeptIds(row.id)
        ]);
        const role = roleRes && roleRes.data;
        const tree = treeRes && treeRes.data;
        const rawDeptIds =
          deptIdsRes && deptIdsRes.data !== undefined ? deptIdsRes.data : [];
        this.scopeForm = {
          id: row.id,
          name: (role && role.name) || row.name,
          code: (role && role.code) || row.code,
          dataScope: role && role.dataScope != null && role.dataScope !== '' ? String(role.dataScope) : '1',
          deptCheckStrictly: true
        };
        this.deptOptions = Array.isArray(tree) ? tree : [];
        this.openDataScope = true;
        const checkedKeys = (rawDeptIds || [])
          .map((id) => (typeof id === 'number' ? id : Number(id)))
          .filter((n) => !isNaN(n));
        this.$nextTick(() => {
          if (this.$refs.deptScope) {
            this.$refs.deptScope.setCheckedKeys(checkedKeys);
          }
        });
      } catch (e) {
        /* 全局拦截已提示；静默避免重复 */
      }
    },
    handleCommand(command, row) {
      switch (command) {
        case "handleDataScope":
          this.handleDataScope(row);
          break;
        case "handleAuthUser":
          this.$message.info("正在开发中...");
          break;
        default:
          break;
      }
    },
    parseTime(time) {
        if (!time) return '';
        const date = new Date(time);
        const y = date.getFullYear();
        const m = (date.getMonth() + 1).toString().padStart(2, '0');
        const d = date.getDate().toString().padStart(2, '0');
        const h = date.getHours().toString().padStart(2, '0');
        const min = date.getMinutes().toString().padStart(2, '0');
        const s = date.getSeconds().toString().padStart(2, '0');
        return `${y}-${m}-${d} ${h}:${min}:${s}`;
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 0;
  background-color: #f8f8f9;
  min-height: calc(100vh - 84px);
}

.query-card {
  border: none;
}

.mb8 {
  margin-bottom: 8px;
}

.right-tool {
  float: right;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.tree-border {
  margin-top: 5px;
  border: 1px solid #e5e6e7;
  background: #fff none;
  border-radius: 4px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.el-dropdown-link {
  cursor: pointer;
  color: #1890ff;
  font-size: 12px;
  margin-left: 10px;
}

/* RuoYi Style Overrides */
.el-table {
  color: #515a6e;
}

.el-table th {
  background-color: #f8f8f9 !important;
  color: #515a6e;
}

.danger-btn {
  color: #ff4d4f !important;
}

.el-button--mini {
    padding: 7px 15px;
}

.el-form-item__label {
    font-weight: 700;
}

.danger-text {
  color: #ff4d4f !important;
}

.danger-text:hover {
  color: #ff7875 !important;
}

.operation-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
}

.operation-cell .el-button,
.operation-cell .el-dropdown {
  margin: 0 5px;
}
</style>
